import { createGetEndpoint } from '@sonar-software/sonar-http';
import { DataSecurityUsage } from '@types';

export const getDataSecurityUsage = createGetEndpoint<void, DataSecurityUsage>(
	'/api/v3/data-security/organization/platform-events-usage'
);
